import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { AnimatedPageLoader } from 'smartsuite-ui';
import InitialState from '../../stateManagement/InitialState';
import DashboardContext from '../../../shared/hooks/dashboardContext';
import widgetDrawConfigurations from '../../widgets/widgetDrawConfigurations';
import ExternalState from '../../stateManagement/ExternalState';
import DashboardPrintView from './DashboardPrintView';
import ViewController from '../../stateManagement/ViewState';
import { getDashboardContextValue } from '../../dashboardUtils';

export default function PrintLayout(props) {
    const widgetRenderers = useMemo(
        () => ({
            ...widgetDrawConfigurations,
            ...props.customizations.widgetRenderers,
        }),
        [props.customizations.widgetRenderers]
    );

    function renderDashboard(isLoaded, loadedSavedDashboard) {
        if (!isLoaded) {
            return <AnimatedPageLoader />;
        }

        return (
            <DashboardPrintView
                dashboardKey={props.dashboardKey}
                printViewMode={props.printViewMode}
                viewConfiguration={loadedSavedDashboard}
            />
        );
    }

    return (
        <InitialState
            dashboardKey={props.dashboardKey}
            favoriteUtilities={props.favoriteUtilities}
            uriConstants={props.uriConstants}
            widgetRenderers={widgetRenderers}
            render={({
                initialStateLoaded,
                selectOptions,
                thresholdValues,
                views,
            }) => (
                <ViewController
                    viewKey={props.viewKey}
                    views={views}
                    render={({ activeView }) => (
                        <ExternalState
                            dashboardKey={props.dashboardKey}
                            initialConfiguration={activeView}
                            initialStateLoaded={initialStateLoaded}
                            location={props.location}
                            selectOptions={selectOptions}
                            uriConstants={props.uriConstants}
                            render={({ isLoaded, loadedSavedDashboard }) => (
                                <DashboardContext.Provider
                                    value={getDashboardContextValue(
                                        props,
                                        selectOptions,
                                        thresholdValues,
                                        widgetRenderers
                                    )}
                                >
                                    {renderDashboard(
                                        isLoaded,
                                        loadedSavedDashboard
                                    )}
                                </DashboardContext.Provider>
                            )}
                        />
                    )}
                />
            )}
        />
    );
}

PrintLayout.propTypes = {
    customizations: PropTypes.instanceOf(Object).isRequired,
    dashboardKey: PropTypes.string.isRequired,
    favoriteUtilities: PropTypes.instanceOf(Object).isRequired,
    location: PropTypes.instanceOf(Object),
    printViewMode: PropTypes.string,
    uriConstants: PropTypes.instanceOf(Object).isRequired,
    viewKey: PropTypes.string,
};

PrintLayout.defaultProps = {
    location: {},
    printViewMode: 'portrait',
    viewKey: '',
};
